import { render } from "./12.AppFooter.vue?vue&type=template&id=502bc9c0&scoped=true"
import script from "./12.AppFooter.vue?vue&type=script&lang=js"
export * from "./12.AppFooter.vue?vue&type=script&lang=js"

import "./12.AppFooter.vue?vue&type=style&index=0&id=502bc9c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502bc9c0"]])

export default __exports__